import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

export const SETTINGS_TAB_IDS = {
  COMPANY_INFO: 'company-info',
  SECURITY: 'security',
  NOTIFICATIONS: 'notifications',
  PRIVACY_NOTICE: 'privacy-notice',
  TERMS_AND_CONDITIONS: 'terms-and-conditions',
};

export const SETTINGS_TABS = [
  {
    id: SETTINGS_TAB_IDS.COMPANY_INFO,
    label: 'Company Info',
    Icon: PersonOutlineIcon,
  },
  {
    id: SETTINGS_TAB_IDS.SECURITY,
    label: 'Security',
    Icon: LockOutlinedIcon,
  },
  {
    id: SETTINGS_TAB_IDS.PRIVACY_NOTICE,
    label: 'Privacy Notice',
    Icon: ShieldOutlinedIcon,
  },
  {
    id: SETTINGS_TAB_IDS.TERMS_AND_CONDITIONS,
    label: 'Terms and Conditions',
    Icon: DescriptionOutlinedIcon,
  },
];
